import { Field } from '@headlessui/react';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Label } from '@/components/form/label';
import { TextInput } from '@/components/form/text-input';
import { Button } from '@/components/ui/button';
import { useCurrentUnit } from '@/hooks/use-current-unit';
import { api } from '@/redux/api';

export type CreateContactFormProps = {
  addressBookId: string;
};
interface formInput {
  contactName: string;
  phoneNumber: string;
}

export const CreateContactForm: FC<CreateContactFormProps> = ({
  addressBookId,
}) => {
  const [createAddressBookContact] = api.useCreateAddressBookContactMutation();
  const { register, handleSubmit } = useForm<formInput>();
  const { data: unit } = useCurrentUnit();
  const onSubmit = (data: formInput) =>
    createAddressBookContact({
      addressBookId: addressBookId,
      contact: { name: data.contactName, phoneNumber: data.phoneNumber },
      actionType: 'createAddressBookContact',
      organisationId: unit?.organisation.id ?? 0,
    });

  return (
    <div>
      <form
        className={'grid-rows grid gap-4'}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="grid-col grid-cols-2">
          <Field className="mt-6 flex min-h-12 flex-col items-start justify-between gap-2">
            <Label>Contact Name:</Label>
            <TextInput
              className={'outline-1 outline-solid'}
              {...register('contactName')}
            ></TextInput>
          </Field>
          <Field className="mt-6 flex min-h-12 flex-col items-start justify-between gap-2">
            <Label>Phone Number:</Label>
            <TextInput
              className={'outline-1 outline-solid'}
              {...register('phoneNumber')}
            ></TextInput>
          </Field>
        </div>
        <Button className="place-self-start" type="submit">
          Add Contact
        </Button>
      </form>
    </div>
  );
};
